<template>
  <div class="boxsizing materialshowbox">
    <div class="phone-box" v-if="!phoneIsDrag">
      <img src="../../../assets/iphonex-menu-bg.png" v-if="menu" class="bg">
      <img src="../../../assets/iphonex-talk-bg.png" v-else class="bg">
      <div class="phone-title">{{user.nick_name}}</div>
      <message-show v-model="messageData" :tips="tips"></message-show>
      <div class="phone-menu" v-if="menu">
        <div :class="menuIndex === index && menuIndexSec === -1 ? 'cur' : ''" v-for="(item, index) in phoneAllData" :key="index" @click="chooseFirstMenu(index)">
          <span class="ellipsis">{{item.name}}</span>
          <i v-show="menuIndex === index" v-if="!isEdit || (item.sub_button && item.sub_button.length > 0)"></i>
          <ul v-show="menuIndex === index" v-if="!isEdit || (item.sub_button && item.sub_button.length > 0)">
            <li v-if="item.sub_button && item.sub_button.length > 0" :class="menuIndex === index && menuIndexSec === index2 ? 'cur' : ''" v-for="(item2, index2) in item.sub_button" :key="index2" @click.stop="chooseSecMenu(index, index2)"><span>{{item2.name}}</span></li>
            <li v-if="(!item.sub_button || (item.sub_button && item.sub_button.length < 5)) && !isEdit" @click.stop="addSubBtn(index)"><span><i class="el-icon-plus"></i></span></li>
          </ul>
        </div>
        <div class="btn-menu-add" v-if="phoneAllData.length < 3" v-show="!isEdit" @click="addMainBtn"><span><i class="el-icon-plus"></i></span></div>
      </div>
    </div>
    <div class="phone-box" v-else>
      <img src="../../../assets/iphonex-menu-bg.png" v-if="menu" class="bg">
      <img src="../../../assets/iphonex-talk-bg.png" v-else class="bg">
      <div class="phone-title">{{user.nick_name}}</div>
      <div class="phone-menu phone-menu-drag" v-if="menu">
        <draggable v-model="phoneAllData">
          <transition-group>
            <div class="menu-first-drag" :class="menuIndex === index && menuIndexSec === -1 ? 'cur' : ''" v-for="(item, index) in phoneAllData" :key="item" @click="chooseFirstMenu(index)">
              <span class="ellipsis">{{item.name}}</span>
              <i v-show="menuIndex === index && phoneAllData[menuIndex].sub_button"></i>
              <ul v-show="menuIndex === index && phoneAllData[menuIndex].sub_button">
                <draggable v-model="item.sub_button">
                  <transition-group>
                    <li v-if="item.sub_button && item.sub_button.length > 0" :class="menuIndex === index && menuIndexSec === index2 ? 'cur' : ''" v-for="(item2, index2) in item.sub_button" :key="item2" @click.stop="chooseSecMenu(index, index2)"><span>{{item2.name}}</span></li>
                  </transition-group>
                </draggable>
              </ul>
            </div>
          </transition-group>
        </draggable>
      </div>
    </div>
    <div style="width: 100%;max-width: 300px;text-align:center;margin-top:20px;" v-if="!isEdit && menu">
      <el-button v-if="!phoneIsDrag" @click="phoneIsDrag = true">菜单排序</el-button>
      <el-button v-else @click="phoneIsDrag = false">确定</el-button>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import draggable from 'vuedraggable'
export default {
  name: 'MaterialMenuPhone',
  props: [
    'value', // 当前显示的回复内容数据
    'menu', // 是否显示菜单
    'isDrag', // 是否可以拖动排序菜单
    'isEdit', // 是否可以编辑(显示排序按钮)
    'allData', // 菜单数据
    'menuIndex', // 一级菜单值
    'menuIndexSec', // 二级菜单值
    'tips' // 是否开启MessageShow组件的素材过期提醒(当与MaterialShow组件一起使用时不需要开启)
  ],
  data () {
    return {
      messageData: {},
      phoneAllData: this.allData,
      phoneIsDrag: this.isDrag
    }
  },
  components: {
    draggable
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  watch: {
    'value': function (val) {
      this.messageData = val
    },
    'allData': function (val) {
      this.phoneAllData = val
    },
    'isDrag': function (val) {
      this.phoneIsDrag = val
    },
    'phoneAllData': function (val) {
      this.$emit('changeVal', {allData: val})
    },
    'phoneIsDrag': function (val) {
      this.$emit('changeVal', {isDrag: val})
    }
  },
  methods: {
    addMainBtn () {
      this.$emit('addMainBtn')
    },
    addSubBtn (index) {
      this.$emit('addSubBtn', index)
    },
    chooseFirstMenu (index) {
      this.$emit('chooseFirstMenu', index)
    },
    chooseSecMenu (first, second) {
      this.$emit('chooseSecMenu', first, second)
    }
  },
  created () {
  },
  mounted () {
    this.messageData = this.value
    this.phoneAllData = this.allData
    this.phoneIsDrag = this.isDrag
  }
}
</script>
<style scoped>
.phone-box {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  max-width: 300px;
}
.phone-box img.bg{
  width: 100%;
  display: block;
}
.phone-title {
  color: #fff;
  position: absolute;
  left: 0;
  top: 8.5%;
  text-align: center;
  width: 100%;
}
.phone-menu {
  position: absolute;
  left: 17%;
  bottom: 6.8%;
  width: 75.5%;
  display: flex;
  height: 5.6%;
}
.phone-menu-drag>div{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-left: none!important;
}
.phone-menu-drag>div>span{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  width: 100%;
  display: flex;
}
.phone-menu div {
  flex: 3;
  box-sizing:border-box;
  border-left: 1px solid #ccc;
  text-align: center;
  display: flex;
  align-items:center;
  font-size: 12px;
  position: relative;
  cursor: pointer;
}
.phone-menu div span {
  margin: 0 auto;
}
.phone-menu div.cur {
  border: 1px solid #44b549;
}
.phone-menu div ul {
  position: absolute;
  border: 1px solid #ccc;
  background: #eee;
  left: 0;
  bottom: 120%;
  width: 100%;
}
.phone-menu div ul div{
  border: none;
}
.phone-menu div ul div span {
  width: 100%;
}
.phone-menu div ul li {
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.phone-menu div ul li.cur{
  border: 1px solid #44b549;
}
.phone-menu div ul li:last-child{
  border-bottom: none;
}
.phone-menu div ul li:last-child.cur{
  border-bottom: 1px solid #44b549;
}
.phone-menu div ul li span {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  width: 80%;
  margin: 0 auto;
}
.phone-menu div>i {
  display: inline-block;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: dashed;
  border-color: transparent;
  border-bottom-width: 0;
  border-top-color: #fafafa;
  border-top-style: solid;
  position: absolute;
  bottom: 108%;
  left: 50%;
  margin-left: -6px;
  z-index: 9;
}
</style>
